<template lang="pug">
  b-field.select-label(:label="label")
    b-dropdown(v-model="innerData" @change="changeValue")
      b-field.has-addons(slot="trigger")
        .control
          //-ui-label(v-if="innerData" :label="innerData" button icon-right="menu-down")
          template(v-if="innerData")
            b-button(icon-left="cube" icon-right="menu-down" :type="innerData.labelColor")
              | {{innerData.name}}
          b-button.has-text-grey(v-else icon-right="menu-down") Платформа

        .control(v-if="withReset && innerData"): b-button.o-9(icon-left="close" @click.stop="changeValue(null)" :type="innerData.labelColor")

      b-dropdown-item(v-for="platform in platforms.items" :key="platform.id" :value="platform")
        b-icon.mr-5(icon="cube" :type="platform.labelColor")
        span {{platform.name}}
</template>

<script>
import Platform from '@/models/Platform';

export default {
  name: 'select-platform',

  props: {
    value: [String, Number],
    platform: Object,
    label: String,
    withReset: Boolean,
    type: String,
  },

  data: () => ({
    platforms: Platform.collection(),
    innerData: null,
  }),

  watch: {
    value(platformId) {
      this.updateInnerData(null, platformId);
    },
  },

  methods: {
    async loadState() {
      let params = {
        include: 'label',
        // filter: { type: this.type },
        sort: 'name',
      };

      if (this.type === 'active') {
        params.scope = 'active';
      }

      await this.platforms.$fetch(params);
      this.$emit('onLoadState', this.platforms);
    },

    changeValue(platform) {
      this.$emit('input', platform ? platform.id : null);
      this.$emit('update:platform', platform);
    },

    updateInnerData(platform, platformId) {
      if (platform) {
        this.innerData = platform;
      } else if (this.platforms) {
        this.innerData = this.platforms.find(platformId);
      }
    },
  },

  async created() {
    this.updateInnerData(this.platform);
    await this.loadState();
    if (!this.platform) {
      this.updateInnerData(null, this.value);
    }
  },
};
</script>
